const baseImageUrl = process.env.REACT_APP_IMAGE_BASE_URL || '';

const getProductImage = (imagePath) => {
  if (!imagePath) return null;

  if (imagePath.includes('http')) return imagePath;

  return `${baseImageUrl}/${imagePath}`;
};

export default getProductImage;
